import { Button, Form, Input } from "antd";

type Address = {
  street: string;
  postCode: string;
  city: string;
};

type Props = {
  initialValues: Address;
  onFinish: (address: Address) => void;
  onReset?: () => void;
};

export function EditAddressForm({ initialValues, onFinish, onReset }: Props) {
  const [form] = Form.useForm();

  const handleFinish = (values: Address) => {
    onFinish(values);
  };

  const handleReset = () => {
    form.resetFields();
    onReset?.();
  };

  return (
    <Form
      form={form}
      initialValues={initialValues}
      onFinish={handleFinish}
      onReset={handleReset}
      layout="vertical"
    >
      <Form.Item
        name="street"
        rules={[
          { required: true, message: "Street & House Number is required" },
        ]}
        className="mb-2"
        label="Street & House Number"
      >
        <Input type="text" placeholder="Eg. Berliner Straße 1" autoFocus />
      </Form.Item>
      <Form.Item
        name="postCode"
        rules={[
          { required: true, message: "Post Code is required" },
          { pattern: /^[0-9]{5}$/, message: "Post Code must be 5 digits" },
        ]}
        className="mb-2"
        label="Post Code"
      >
        <Input type="text" placeholder="Eg. 12345" />
      </Form.Item>
      <Form.Item
        name="city"
        rules={[{ required: true, message: "City is required" }]}
        className="mb-1"
        label="City"
      >
        <Input type="text" placeholder="Eg. Berlin" />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
        <Button htmlType="reset" className="ml-2">
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
}
